import { render, staticRenderFns } from "./Detail-ErrorCode.vue?vue&type=template&id=48fd9b87"
import script from "./Detail-ErrorCode.vue?vue&type=script&lang=js"
export * from "./Detail-ErrorCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports